import { useState, useEffect } from "react";
import VentanaFlotante from "../../componentes/ventanaFlotante.js";
import Constantes from "../../constantes";

function Mensajes() {
    const [ventanas, setVentanas] = useState([]);
    const [amigos, setAmigos] = useState([]);
    const [solicitudes, setSolicitudes] = useState([]);
    const [busquedaUsuarios, setBusquedaUsuarios] = useState([]);
    const [busquedaAmigos, setBusquedaAmigos] = useState("");


    async function recargarDatos() {
        try {
            await fetch(Constantes.RUTA_API + "/amigos/getAmigos", {
                method: "GET",
                credentials: "include"
            }).then(res => res.json())
            .then(data => setAmigos(data.message))
            .catch(err => console.error("Error al cargar amigos:", err));

            await fetch(Constantes.RUTA_API + "/amigos/getSolicitudes", {
                method: "GET",
                credentials: "include"
            }).then(res => res.json())
            .then(data => setSolicitudes(data.message))
            .catch(err => console.error("Error al cargar solicitudes:", err));

        } catch (err) {
            console.error("Error al recargar datos:", err);
        }
    }

    useEffect(() => {
        recargarDatos();
    }, []);


    async function buscarUsuarios() {
        try {
            const respuesta = await fetch(Constantes.RUTA_API + '/usuarios/searchUsers?nombre=' + encodeURIComponent(document.getElementById('busquedaUsuario').value), {
                method: 'GET',
                credentials: 'include'
            })
            const data = await respuesta.json();
            console.log("Resultado búsqueda usuarios:", data);
            if (!data.error) {
                setBusquedaUsuarios(data);
            } else {
                console.error('Error al buscar usuarios:', data.message);
            }
        } catch (error) {
            console.error('Error al buscar usuarios:', error);
        }
    }

    async function enviarInvitacion(usuarioId) {
        try {
            const resultado = await fetch(Constantes.RUTA_API + '/amigos/enviarSolicitud', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ usuarioId })
            });
            const data = await resultado.json();
            if (!data.error) {
                console.log('Invitación enviada:', data.message);
            } else {
                console.error('Error al enviar invitación:', data.message);
            }
            alert(data.message);
        } catch (error) {
            console.error('Error al enviar invitación:', error);
        }
    }

    function nombreA360(nombre) {
        let hash = 0;

        for (let i = 0; i < nombre.length; i++) {
            hash = (hash * 31 + nombre.charCodeAt(i) * 31) >>> 0;
        }

        return hash % 360;
    }

    const abrirVentana = (amigo) => {
        const existe = ventanas.find((v) => v.id === amigo.id);
        if (existe) return; // Ya está abierta

        setVentanas((prev) => [
            ...prev,
            { id: amigo.id, nombre: amigo.nombre, color: `hsl(${nombreA360(amigo.nombre)}, 70%, 80%)`, z: prev.length + 1 }
        ]);
    };

    const cerrarVentana = (id) => {
        setVentanas((prev) => prev.filter((v) => v.id !== id));
    };

    const aceptarSolicitud = (solicitudId) => {

        fetch(Constantes.RUTA_API + "/amigos/aceptarSolicitud", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ solicitudId })
        })
            .then(res => res.json())
            .then(data => {
                console.log("Respuesta al aceptar solicitud:", data);
                if (!data.error) {
                    setSolicitudes((prev) => prev.filter((s) => s.solicitudId !== solicitudId));
                }
                else {
                    console.error("Error al aceptar la solicitud:", data.message);
                }
            })
            .catch(err => console.error("Error al aceptar la solicitud:", err))
            .finally(()=>recargarDatos());



    };
    const rechazarSolicitud = (solicitudId) => {

        fetch(Constantes.RUTA_API + "/amigos/rechazarSolicitud", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ solicitudId })
        })
            .then(res => res.json())
            .then(data => {
                console.log("Respuesta al rechazar solicitud:", data);
                if (!data.error) {
                    setSolicitudes((prev) => prev.filter((s) => s.solicitudId !== solicitudId));
                }
                else {
                    console.error("Error al rechazar la solicitud:", data.message);
                }
            })
            .catch(err => console.error("Error al rechazar la solicitud:", err))
            .finally(()=>recargarDatos());

    };
    const focusVentana = (id) => {
        setVentanas((prev) =>
            prev.map((v) =>
                v.id === id ? { ...v, z: prev.length } : v
            )
        );
    };

    const amigosFiltrados = amigos.filter((amigo) =>
        amigo.nombre.toLowerCase().includes(busquedaAmigos.toLowerCase())
    );




    return (
        <>
            <div className="App d-flex bg-dark text-white row marginLess" style={{ overflow: "hidden", boxSizing: "border-box" }}>
                <div className="col-md-2 col-sm-12 paddingLess" style={{ display: "flex", flexDirection: "column", height: "100%", boxSizing: "border-box" }}>
                    <div style={{ backgroundColor: "black", overflowY: "auto", flex: 1, boxSizing: "border-box" }}>
                        <h5 style={{ padding: "5px", margin: 0, boxSizing: "border-box" }}>Amigos</h5>
                        <input
                            type="text"
                            placeholder="Buscar amigo..."
                            value={busquedaAmigos}
                            onChange={(e) => setBusquedaAmigos(e.target.value)}
                            style={{
                                width: "calc(100% - 20px)",
                                padding: "8px 10px",
                                borderRadius: "5px",
                                border: "none",
                                margin: "5px 10px",
                                height: "35px",
                                boxSizing: "border-box"
                            }}
                        />
                        {amigosFiltrados.map((amigo, i) => (
                            <button
                                key={i}
                                onClick={() => abrirVentana(amigo)}
                                style={{ display: "block", margin: "5px", borderRadius: "8px" }}
                            >
                                {amigo.nombre}
                            </button>
                        ))}
                    </div>
                    <div style={{ backgroundColor: "black", overflowY: "auto", flex: 1, boxSizing: "border-box" }}>
                        <h5 style={{ padding: "5px", margin: 0, boxSizing: "border-box" }}>Solicitudes de amistad</h5>
                        {solicitudes.map((solicitud, i) => (
                            <div key={i} style={{ display: "block", margin: "5px", borderRadius: "8px" }}>
                                {console.log("solicitud", solicitud)}
                                {solicitud.usuario.nombre}
                                <button style={{ marginLeft: "5px" }} onClick={() => aceptarSolicitud(solicitud.solicitudId)}>Aceptar</button>
                                <button style={{ marginLeft: "5px" }} onClick={() => rechazarSolicitud(solicitud.solicitudId)}>Rechazar</button>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="col-md-10 col-sm-12 paddingLess" style={{ display: "flex", flexDirection: "column", height: "100%", boxSizing: "border-box" }}>
                    <h5 style={{ padding: "5px 10px", margin: 0, boxSizing: "border-box" }}>Buscar usuario</h5>
                    <input id="busquedaUsuario" type="text" placeholder="Buscar usuario..." style={{ margin: "5px 10px", padding: "8px", borderRadius: "5px", border: "none", height: "35px", boxSizing: "border-box" }} />
                    <button style={{ display: "block", margin: "5px 10px", borderRadius: "8px", width: "150px", padding: "5px" }} onClick={() => buscarUsuarios()}>Buscar</button>

                    <div style={{ overflowY: "auto", flex: 1, boxSizing: "border-box" }}>
                        {busquedaUsuarios.length === 0 ? (
                            <p className="text-center">No se ha encontrado ningún usuario con ese nombre.</p>
                        ) : (
                            <ul className="list-unstyled">
                                {busquedaUsuarios.map((usuario) => {
                                    return (
                                        <li key={usuario.id} className="mb-3 p-3 border rounded shadow-sm">
                                            <div className="d-flex justify-content-between align-items-center"
                                            >
                                                <strong>Usuario: {usuario.nombre}</strong>

                                                <button className="btn btn-success btn-sm" onClick={() => enviarInvitacion(usuario.id)}>enviar solicitud</button>

                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                </div>

                {/* Renderizamos las ventanas flotantes */}
                {ventanas.map((v) => (
                    <VentanaFlotante
                        key={v.id}
                        id={v.id}
                        nombre={v.nombre}
                        color={v.color}
                        z={v.z}
                        onClose={() => cerrarVentana(v.id)}
                        onFocus={() => focusVentana(v.id)}
                    />
                ))}
            </div>
        </>
    );
}

export default Mensajes;
